import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Card,
    IconButton,
    Modal,
    Skeleton,
    Stack,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BILightGrey } from "../../assets/helpers";
import {
    FETCH_CLIENT_EQUIPMENT_INSPECTION_TYPE
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function NewEquipmentInspections({open,setOpen}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [inspectionTypes, setInspectionTypes] = useState([]);
  const [typesLoading, setTypesLoading] = useState(false);

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state.main);
  const userId = loginData?.userInformation?.UserId;
  const LANGUAGE = ClientEnglishFallback.EquipmentInspections(
    multiLanguageData?.EquipmentInspections || {}
  );
  const { TEXT_NEW_INSPECTION, TEXT_NO_INSPECTION_SECOND } = LANGUAGE;

  useEffect(() => {
    fetchEquipmentInspectionsTypes();
  }, [location]);

  const fetchEquipmentInspectionsTypes = async () => {
    setTypesLoading(true)
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };

      const response = await Postrequestcall(
        FETCH_CLIENT_EQUIPMENT_INSPECTION_TYPE,
        obj,
        loginData?.accessToken
      );

      if (response) {
        setInspectionTypes(response?.data?.data);
      }
    } catch (error) {
      console.log("fetchEquipmentInspectionsTypes-> Error When Fetching Equipment Inspection Types", error);
    } finally {
      setTypesLoading(false)
    }
  };

  const handleFormClick = (form) => {
    navigate(`${form.id}`);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-view-client-support"
        aria-describedby="modal-view-client">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            width: "90%",
            maxWidth: 500,
            maxHeight: "80vh",
            overflowY: "auto"
          }}>
          {
            typesLoading ? (
              <Card  style={{ padding: '15px', boxShadow:'none' }} >
                <Stack spacing={2}>
                  <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
                    <Skeleton variant="text" width="40%" height={28} />
                    <Skeleton variant="circular" width={24} height={24} />
                  </Stack>

                  {[...Array(7)].map((_, index) => (
                    <Skeleton key={index} variant="rectangular" height={48} sx={{ borderRadius: 1 }} />
                  ))}
                </Stack>
              </Card>):(
                <>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6" gutterBottom>
                      {TEXT_NEW_INSPECTION}
                    </Typography>
                    <IconButton
                      className="view-close"
                      sx={{
                        color:
                          selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                            ? selectedClientData?.AccentColor
                            : BILightGrey
                      }}
                      onClick={() => setOpen(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  {inspectionTypes.length > 0 ? (
                    <Stack sx={{ gap: 2 }} direction="column" >
                      {inspectionTypes.map((form) => (
                        <Box
                          key={form.id}
                          sx={{
                            borderRadius: 2,
                            cursor: "pointer",
                            p: 2,

                            border: "1px solid #e4e4e4"
                          }}
                          onClick={() => handleFormClick(form)}>
                          <Box
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="body1">{form.name}</Typography>
                            <ChevronRightIcon color="action" />
                          </Box>
                        </Box>
                      ))}
                    </Stack>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <Typography variant="body1" sx={{ color: "text.secondary" }}>
                        {`${selectedClientData?.OrganizationName} ${TEXT_NO_INSPECTION_SECOND}`}
                      </Typography>
                    </Box>
                  )}
                </>
                )
              }
        </Box>

      </Modal >
    </>
  );
}

